import { render, staticRenderFns } from "./BomInfoTable.vue?vue&type=template&id=aed0b0ea&"
import script from "./BomInfoTable.vue?vue&type=script&lang=js&"
export * from "./BomInfoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports